export default __webpack_public_path__ + "static/media/image 30.57b2e72d.png";